export default "__VITE_ASSET__DUm9KYT8__"